import { Col, Row, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "./BudgetReportCR.css";
import {
  GetViewAutoBudgetDepartment,
  GetYearBudget,
} from "../../Services/BudgetReportService";
import { Button } from "primereact/button";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

function BudgetByDepartmentFiscalYear() {
  const [loading, setLoading] = useState(false);
  const [pageSize] = useState<number>(10);

  // Table Data
  const [incomeData, setIncomeData] = useState<any[]>([]);
  const [expenseData, setExpenseData] = useState<any[]>([]);
  const [fixedAssetData, setFixedAssetData] = useState<any[]>([]);

  // Table Columns
  const [incomeColumns, setIncomeColumns] = useState<any[]>([]);
  const [expenseColumns, setExpenseColumns] = useState<any[]>([]);
  const [fixedAssetColumns, setFixedAssetColumns] = useState<any[]>([]);

  // rawRow เก็บ data rows ทั้งหมด จาก API
  const [rawRow, setRawRow] = useState<any[]>([]);

  // Filter
  const [selectedYear, setSelectedYear] = useState<string>(
    (new Date().getFullYear() + 543).toString(),
  );
  const [selectedDivision, setSelectedDivision] = useState<string[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<string[]>([]);

  // Dropdown options
  const [divisionOption, setDivisionOption] = useState<any[]>([]);
  const [departmentOption, setDepartmentOption] = useState<any[]>([]);
  const [yearOption, setYearOption] = useState<any[]>([]);

  // เก็บ data ที่ Filter
  const [filterIncomeData, setFilterIncomeData] = useState<any[] | null>(null);
  const [filterExpenseData, setFilterExpenseData] = useState<any[] | null>(
    null,
  );
  const [filterFixedAssetData, setFilterFixedAssetData] = useState<
    any[] | null
  >(null);

  // key data
  const [incomeTableKeys, setIncomeTableKeys] = useState<string[]>([]);
  const [expenseTableKeys, setExpenseTableKeys] = useState<string[]>([]);
  const [fixedAssetTableKeys, setFixedAssetTableKeys] = useState<string[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  // fetchData GetViewAutoBudgetDepartment
  const fetchData = async () => {
    setLoading(true);

    const resYear = await GetYearBudget({
      ViewName: "vw_BG01_BudgetSummary",
    });

    if (resYear.rows && resYear.rows.length > 0) {
      const dataJson = {
        BudgetYear: selectedYear.toString(),
      };

      const res = await GetViewAutoBudgetDepartment(dataJson);

      if (res.rows && res.rows.length > 0) {
        // data response
        setRawRow(res.rows);

        // year Option
        const years = Array.from(
          new Set(
            resYear.rows
              .map((r: any) => r.BudgetYear)
              .filter((y: any) => y !== null),
          ),
        ).sort();
        
        setYearOption(
          years.map((y: any) => ({
            label: y,
            value: y,
          })),
        );


        // divisions Option
        const divisions = Array.from(
          new Set(
            res.rows.map((r: any) => r.Division).filter((d: any) => d != null),
          ),
        );

        setDivisionOption(
          divisions.map((d: any) => ({
            label: d,
            value: d,
          })),
        );
      } else {
        setRawRow([]);
        setDivisionOption([]);
        setDepartmentOption([]);
        setFilterIncomeData(null);
        setFilterExpenseData(null);
        setFilterFixedAssetData(null);
        setIncomeTableKeys([]);
        setExpenseTableKeys([]);
        setFixedAssetTableKeys([]);
      }
    } else {
      setRawRow([]);
      setYearOption([]);
      setDivisionOption([]);
      setDepartmentOption([]);
      setFilterIncomeData(null);
      setFilterExpenseData(null);
      setFilterFixedAssetData(null);
      setIncomeTableKeys([]);
      setExpenseTableKeys([]);
      setFixedAssetTableKeys([]);
      
    }

    setLoading(false);
  };

  // onChange Year
  const handleYearChange = async (year: any) => {
    setSelectedYear(year);
    setSelectedDivision([]);
    setSelectedDepartment([]);

    if (!year) return;

    try {
      setLoading(true);

      const dataJson = {
        BudgetYear: year.toString(),
      };

      const data = await GetViewAutoBudgetDepartment(dataJson);

      if (data?.rows?.length > 0) {
        setRawRow(data.rows);

        const divisions = Array.from(
          new Set(
            data.rows.map((r: any) => r.Division).filter((d: any) => d != null),
          ),
        );

        setDivisionOption(
          divisions.map((d: any) => ({
            label: d,
            value: d,
          })),
        );

        const departments = Array.from(
          new Set(
            data.rows
              .map((r: any) => r.Department)
              .filter((d: any) => d != null),
          ),
        );

        setDepartmentOption(
          departments.map((d: any) => ({
            label: d,
            value: d,
          })),
        );
      } else {
        setRawRow([]);
        setDivisionOption([]);
        setDepartmentOption([]);
      }

      setFilterIncomeData(null);
      setFilterExpenseData(null);
      setFilterFixedAssetData(null);
    } catch (error) {
      console.error("Error loading year data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Sync Department ตาม Division
  useEffect(() => {
    if (!rawRow.length) return;

    // ถ้าไม่มี division แสดง department ทั้งหมด
    // ถ้าเลือก division ใหม่ ตัด department ที่ไม่เกี่ยวออก

    if (selectedDivision.length === 0) {
      const departments = Array.from(new Set(rawRow.map((r) => r.Department)));

      setDepartmentOption(departments.map((d) => ({ label: d, value: d })));

      return;
    }

    // filter department ตาม division
    const filteredDepartments = Array.from(
      new Set(
        rawRow
          .filter((r) => selectedDivision.includes(r.Division))
          .map((r) => r.Department),
      ),
    );

    setDepartmentOption(
      filteredDepartments.map((d) => ({
        label: d,
        value: d,
      })),
    );

    // ตัด department ที่ไม่ตรง division ออก
    setSelectedDepartment((prev) =>
      prev.filter((dept) => filteredDepartments.includes(dept)),
    );
  }, [selectedDivision, rawRow]);

  // master filter ทุก table
  const getFilteredRows = () => {
    let filtered = [...rawRow];

    if (selectedDivision.length > 0) {
      filtered = filtered.filter((r) => selectedDivision.includes(r.Division));
    }

    if (selectedDepartment.length > 0) {
      filtered = filtered.filter((r) =>
        selectedDepartment.includes(r.Department),
      );
    }

    return filtered;
  };

  // set table ทุกครั้งที่ filter
  useEffect(() => {
    const filtered = getFilteredRows();

    const divisionMap: any = {};

    filtered.forEach((r: any) => {
      if (!divisionMap[r.Division]) divisionMap[r.Division] = [];
      if (!divisionMap[r.Division].includes(r.Department)) {
        divisionMap[r.Division].push(r.Department);
      }
    });

    const income = transformRows(filtered, "income", divisionMap);
    const expense = transformRows(filtered, "expenses", divisionMap);
    const fixed = transformRows(filtered, "FixedAssets", divisionMap);

    setIncomeColumns(groupColumns(divisionMap, income));
    setExpenseColumns(groupColumns(divisionMap, expense));
    setFixedAssetColumns(groupColumns(divisionMap, fixed));

    setIncomeData(income);
    setExpenseData(expense);
    setFixedAssetData(fixed);

    // sync table filter ให้ถูกต้อง
    if (incomeTableKeys.length === 0) {
      setFilterIncomeData(null);
    } else {
      const synced = income.filter((row: any) =>
        incomeTableKeys.includes(row.key),
      );
      setFilterIncomeData(synced);
    }

    if (expenseTableKeys.length === 0) {
      setFilterExpenseData(null);
    } else {
      const synced = expense.filter((row: any) =>
        expenseTableKeys.includes(row.key),
      );
      setFilterExpenseData(synced);
    }

    if (fixedAssetTableKeys.length === 0) {
      setFilterFixedAssetData(null);
    } else {
      const synced = fixed.filter((row: any) =>
        fixedAssetTableKeys.includes(row.key),
      );
      setFilterFixedAssetData(synced);
    }
  }, [
    selectedDivision,
    selectedDepartment,
    rawRow,
    incomeTableKeys,
    expenseTableKeys,
    fixedAssetTableKeys,
  ]);

  // set columns and group columns
  const groupColumns = (divisionMap: any, tableData: any[]) => {
    const columns: any[] = [
      {
        title: "รหัสบัญชี",
        dataIndex: "AccountCode",
        key: "AccountCode",
        width: 160,
        fixed: "left",
        filters: Array.from(
          new Set(tableData.map((item) => item.AccountCode)),
        ).map((name) => ({
          text: name,
          value: name,
        })),
        onFilter: (value: any, record: any) => record.AccountCode === value,
        filterMultiple: true,
        filterSearch: true,
      },
      {
        title: "ชื่อหมวดบัญชี",
        dataIndex: "AccountName",
        key: "AccountName",
        width: 260,
        fixed: "left",
        filters: Array.from(
          new Set(tableData.map((item) => item.AccountName)),
        ).map((name) => ({
          text: name,
          value: name,
        })),
        onFilter: (value: any, record: any) => record.AccountName === value,
        filterMultiple: true,
        filterSearch: true,
      },
      {
        title: "ส.อ.ท.",
        dataIndex: "TotalDivision",
        key: "TotalDivision",
        align: "right",
        fixed: "left",
        width: 180,
        render: (value: any) =>
          Number(value || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
      },
    ];

    const divisionColumns = Object.keys(divisionMap).map((division) => ({
      title: division,
      align: "center",
      children: divisionMap[division].map((dept: any) => ({
        title: dept,
        dataIndex: `${division}_${dept}`,
        key: `${division}_${dept}`,
        align: "right",
        width: 200,
        render: (value: any) =>
          typeof value === "number"
            ? value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              })
            : value,
      })),
    }));

    return [...columns, ...divisionColumns];
  };

  // แปลง key rows table
  const transformRows = (
    rows: any[],
    type: string,
    divisionMap: Record<string, string[]>,
  ) => {
    const grouped: any = {};

    rows
      .filter((item) => item.TypeGroup === type)
      .forEach((item) => {
        // group แค่ รหัสบัญชี + ชื่อหมวดบัญชี
        const key = `${item.AccountCode}_${item.AccountName}`;

        const division = item.Division ?? "ไม่มีหน่วยงาน";
        const department = item.Department ?? "ไม่มีสายงาน";
        const dataKey = `${division}_${department}`;

        if (!grouped[key]) {
          grouped[key] = {
            key,
            AccountCode: item.AccountCode,
            AccountName: item.AccountName,
            TotalDivision: 0,
          };
        }

        const amount = Number(item.Total || 0);

        if (!grouped[key][dataKey]) {
          grouped[key][dataKey] = 0;
        }

        grouped[key][dataKey] += amount;
        grouped[key].TotalDivision += amount;
      });

    Object.values(grouped).forEach((row: any) => {
      Object.entries(divisionMap).forEach(([division, depts]) => {
        depts.forEach((dept) => {
          const colKey = `${division}_${dept}`;
          if (row[colKey] === undefined) {
            // ถ้าไม่มีให้เป็น 0
            row[colKey] = 0;
          }
        });
      });
    });

    return Object.values(grouped);
  };

  // get column summary low
  const getLeafColumns = (columns: any[]) => {
    const leaf: any[] = [];
    columns.forEach((col) => {
      if (!col.children) leaf.push(col);
      else col.children.forEach((child: any) => leaf.push(child));
    });
    return leaf;
  };

  // export ทุกตาราง
  const exportFullReport = () => {
    const wb = XLSX.utils.book_new();
    const wsData: any[][] = [];
    const headerRowIndexes: number[] = [];

    // ถ้ามี filter
    const exportIncome =
      filterIncomeData !== null ? [...filterIncomeData] : [...incomeData];

    const exportExpense =
      filterExpenseData !== null ? [...filterExpenseData] : [...expenseData];

    const exportFixed =
      filterFixedAssetData !== null
        ? [...filterFixedAssetData]
        : [...fixedAssetData];

    // header
    wsData.push(["รายงานงบประมาณของ ส.อ.ท. ประจำปีงบประมาณ " + selectedYear]);
    wsData.push([]);

    // build Section
    const buildSection = (
      title: string,
      columns: any[],
      data: any[],
      totalLabel: string,
    ) => {
      wsData.push([title]);
      wsData.push([]);

      const headerRow1: any[] = [];
      const headerRow2: any[] = [];
      const leafColumns: any[] = [];

      columns.forEach((col: any) => {
        if (!col.children) {
          headerRow1.push(col.title);
          headerRow2.push("");
          leafColumns.push(col);
        } else {
          const childCount = col.children.length;

          headerRow1.push(col.title);
          for (let i = 1; i < childCount; i++) {
            headerRow1.push("");
          }

          col.children.forEach((child: any) => {
            headerRow2.push(child.title);
            leafColumns.push(child);
          });
        }
      });

      const headerStartIndex = wsData.length;
      wsData.push(headerRow1);
      wsData.push(headerRow2);

      headerRowIndexes.push(headerStartIndex);
      headerRowIndexes.push(headerStartIndex + 1);

      // data
      data.forEach((row: any) => {
        wsData.push(leafColumns.map((col: any) => row[col.dataIndex] ?? 0));
      });

      // total
      const totalRow: any[] = [];

      leafColumns.forEach((col: any, index: number) => {
        if (index === 0) totalRow.push(totalLabel);
        else if (index === 1) totalRow.push("");
        else {
          const sum = data.reduce(
            (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
            0,
          );
          totalRow.push(sum);
        }
      });

      wsData.push(totalRow);
      wsData.push([]);
      wsData.push([]);
    };

    // section
    buildSection("รายได้", incomeColumns, exportIncome, "รวมรายได้");
    buildSection("ค่าใช้จ่าย", expenseColumns, exportExpense, "รวมค่าใช้จ่าย");

    // สุทธิ
    const leafColumns: any[] = [];

    expenseColumns.forEach((col: any) => {
      if (!col.children) leafColumns.push(col);
      else col.children.forEach((child: any) => leafColumns.push(child));
    });

    const netRow: any[] = [];

    leafColumns.forEach((col: any, index: number) => {
      if (index === 0) netRow.push("สุทธิ");
      else if (index === 1) netRow.push("");
      else {
        const totalIncome = exportIncome.reduce(
          (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
          0,
        );

        const totalExpense = exportExpense.reduce(
          (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
          0,
        );

        netRow.push(totalIncome - totalExpense);
      }
    });

    wsData.push(netRow);
    wsData.push([]);
    wsData.push([]);

    buildSection(
      "สินทรัพย์ถาวร",
      fixedAssetColumns,
      exportFixed,
      "รวมสินทรัพย์ถาวร",
    );

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // merges header
    const merges: any[] = [];
    const sectionColumnsList = [
      incomeColumns,
      expenseColumns,
      fixedAssetColumns,
    ];

    headerRowIndexes.forEach((rowIndex, idx) => {
      if (idx % 2 !== 0) return;

      const sectionIndex = Math.floor(idx / 2);
      const sectionColumns = sectionColumnsList[sectionIndex];

      let colIndex = 0;

      sectionColumns.forEach((col: any) => {
        if (!col.children) {
          colIndex++;
        } else {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: {
              r: rowIndex,
              c: colIndex + col.children.length - 1,
            },
          });
          colIndex += col.children.length;
        }
      });
    });

    ws["!merges"] = merges;

    // style
    const range = XLSX.utils.decode_range(ws["!ref"] as string);
    const sectionTitles = ["รายได้", "ค่าใช้จ่าย", "สินทรัพย์ถาวร"];

    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddress]) continue;

        const value = ws[cellAddress].v;

        const isSectionTitle = sectionTitles.includes(value);
        const isMainTitle = R === 0 || R === 1;
        const isHeaderRow = headerRowIndexes.includes(R);

        const isNumber =
          typeof value === "number" ||
          (!isNaN(Number(value)) && value !== "" && value !== null);

        ws[cellAddress].s = {
          font: {
            bold: isSectionTitle || isMainTitle,
          },
          alignment: {
            vertical: "center",
            horizontal: isHeaderRow
              ? "center"
              : C === 0
                ? "left"
                : isNumber
                  ? "right"
                  : "left",
          },
          border:
            isSectionTitle || isMainTitle
              ? undefined
              : {
                  top: { style: "thin" },
                  bottom: { style: "thin" },
                  left: { style: "thin" },
                  right: { style: "thin" },
                },
        };

        if (isNumber && !isHeaderRow && C !== 0) {
          ws[cellAddress].t = "n";
          ws[cellAddress].z = "#,##0.00";
        }
      }
    }

    // auto width
    const colWidths: any[] = [];

    wsData[5].forEach((_: any, colIndex: number) => {
      if (colIndex === 0) {
        colWidths.push({ wch: 16 });
        return;
      }

      if (colIndex === 1) {
        colWidths.push({ wch: 28 });
        return;
      }

      let maxLength = 10;

      for (let i = 5; i < wsData.length; i++) {
        const cell = wsData[i][colIndex];
        if (cell !== undefined && cell !== null) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      }

      colWidths.push({ wch: maxLength + 4 });
    });

    ws["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, "รายงานงบประมาณ");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], {
        type: "application/octet-stream",
      }),
      `FTIBudgetByDepartmentFiscalYear_${selectedYear}.xlsx`,
    );
  };

  // export แยกแต่ละตาราง
  const exportSectionReport = (
    fileName: string,
    sheetName: string,
    title: string,
    columns: any[],
    data: any[],
    totalLabel: string,
  ) => {
    const wb = XLSX.utils.book_new();
    const wsData: any[][] = [];
    const headerRowIndexes: number[] = [];

    console.log(
      "exportSectionReport_filterExpenseData",
      filterExpenseData,
      expenseData,
      filterIncomeData,
      incomeData,
      fixedAssetData,
      filterFixedAssetData,
    );

    // data หลัง filter
    let exportData: any[] = [];

    if (sheetName === "รายได้") {
      exportData =
        filterIncomeData !== null ? [...filterIncomeData] : [...incomeData];
    } else if (sheetName === "ค่าใช้จ่าย") {
      exportData =
        filterExpenseData !== null ? [...filterExpenseData] : [...expenseData];
    } else if (sheetName === "สินทรัพย์ถาวร") {
      exportData =
        filterFixedAssetData !== null
          ? [...filterFixedAssetData]
          : [...fixedAssetData];
    }

    if (!exportData) exportData = [];

    // header
    wsData.push(["รายงานงบประมาณของ ส.อ.ท. ประจำปีงบประมาณ " + selectedYear]);
    wsData.push([]);
    wsData.push([title]);
    wsData.push([]);

    const headerRow1: any[] = [];
    const headerRow2: any[] = [];
    const leafColumns: any[] = [];

    columns.forEach((col: any) => {
      if (!col.children) {
        headerRow1.push(col.title);
        headerRow2.push("");
        leafColumns.push(col);
      } else {
        const childCount = col.children.length;

        headerRow1.push(col.title);
        for (let i = 1; i < childCount; i++) {
          headerRow1.push("");
        }

        col.children.forEach((child: any) => {
          headerRow2.push(child.title);
          leafColumns.push(child);
        });
      }
    });

    const headerStartIndex = wsData.length;
    wsData.push(headerRow1);
    wsData.push(headerRow2);

    headerRowIndexes.push(headerStartIndex);
    headerRowIndexes.push(headerStartIndex + 1);

    // data
    exportData.forEach((row: any) => {
      wsData.push(leafColumns.map((col: any) => row[col.dataIndex] ?? 0));
    });

    // total
    const totalRow: any[] = [];

    leafColumns.forEach((col: any, index: number) => {
      if (index === 0) {
        totalRow.push(totalLabel);
      } else if (index === 1) {
        totalRow.push("");
      } else {
        const sum = exportData.reduce(
          (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
          0,
        );
        totalRow.push(sum);
      }
    });

    wsData.push(totalRow);

    // net
    if (sheetName === "ค่าใช้จ่าย") {
      const exportIncome =
        filterIncomeData !== null ? filterIncomeData : incomeData;

      const netRow: any[] = [];

      leafColumns.forEach((col: any, index: number) => {
        if (index === 0) {
          netRow.push("สุทธิ");
        } else if (index === 1) {
          netRow.push("");
        } else {
          const totalIncome = exportIncome.reduce(
            (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
            0,
          );

          const totalExpense = exportData.reduce(
            (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
            0,
          );

          netRow.push(totalIncome - totalExpense);
        }
      });

      wsData.push(netRow);
    }

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // merges header
    const merges: any[] = [];
    const sectionColumnsList = [columns];

    headerRowIndexes.forEach((rowIndex, idx) => {
      if (idx % 2 !== 0) return;

      const sectionIndex = Math.floor(idx / 2);
      const sectionColumns = sectionColumnsList[sectionIndex];

      let colIndex = 0;

      sectionColumns.forEach((col: any) => {
        if (!col.children) {
          colIndex++;
        } else {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: {
              r: rowIndex,
              c: colIndex + col.children.length - 1,
            },
          });
          colIndex += col.children.length;
        }
      });
    });

    ws["!merges"] = merges;

    // style
    const range = XLSX.utils.decode_range(ws["!ref"] as string);
    const sectionTitles = ["รายได้", "ค่าใช้จ่าย", "สินทรัพย์ถาวร"];

    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddress]) continue;

        const value = ws[cellAddress].v;

        const isSectionTitle = sectionTitles.includes(value);
        const isMainTitle = R === 0 || R === 1;
        const isHeaderRow = headerRowIndexes.includes(R);

        const isNumber =
          typeof value === "number" ||
          (!isNaN(Number(value)) && value !== "" && value !== null);

        ws[cellAddress].s = {
          font: {
            bold: isSectionTitle || isMainTitle,
          },
          alignment: {
            vertical: "center",
            horizontal: isHeaderRow
              ? "center"
              : C === 0
                ? "left"
                : isNumber
                  ? "right"
                  : "left",
          },
          border:
            isSectionTitle || isMainTitle
              ? undefined
              : {
                  top: { style: "thin" },
                  bottom: { style: "thin" },
                  left: { style: "thin" },
                  right: { style: "thin" },
                },
        };

        if (isNumber && !isHeaderRow && C !== 0) {
          ws[cellAddress].t = "n";
          ws[cellAddress].z = "#,##0.00";
        }
      }
    }

    // column width
    const colWidths: any[] = [];

    leafColumns.forEach((_, i) => {
      if (i === 0) {
        colWidths.push({ wch: 16 });
        return;
      }

      if (i === 1) {
        colWidths.push({ wch: 28 });
        return;
      }

      let maxLength = 10;

      wsData.forEach((row) => {
        const cell = row[i];
        if (cell !== undefined && cell !== null) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      });

      colWidths.push({ wch: maxLength + 4 });
    });

    ws["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], {
        type: "application/octet-stream",
      }),
      fileName + ".xlsx",
    );
  };

  return (
    <div style={{ padding: 36 }}>
      {/* Header */}
      <Row
        justify="center"
        align="middle"
        style={{
          backgroundColor: "#282F6A",
          padding: "1rem",
          borderRadius: "8px",
        }}
      >
        <Col
          span={24}
          className="text-header-report"
          style={{ textAlign: "center" }}
        >
          รายงานงบประมาณของ ส.อ.ท. แยกตามสายงาน
        </Col>
        <Col
          span={24}
          className="sub-text-header-report"
          style={{ textAlign: "center" }}
        >
          ประจำปีงบประมาณ {selectedYear}
        </Col>
      </Row>

      {/* Filters */}
      <Row
        gutter={[16, 16]}
        style={{
          marginTop: "2rem",
          padding: "1.5rem",
          backgroundColor: "#f0f2f5",
          borderRadius: "12px",
          border: "1px solid #d9d9d9",
        }}
      >
        {/* ปีงบประมาณ */}
        <Col xs={24} sm={12} md={12} lg={4} xl={4}>
          <div className="filter-label">ปีงบประมาณ (Year)</div>
          <Select
            options={yearOption}
            value={selectedYear}
            onChange={handleYearChange}
            style={{ width: "100%" }}
            size="large"
          />
        </Col>

        {/* Division */}
        <Col xs={24} sm={12} md={12} lg={7} xl={7}>
          <div className="filter-label">หน่วยงาน (Division)</div>
          <Select
            mode="multiple"
            options={divisionOption}
            value={selectedDivision}
            onChange={(value) => setSelectedDivision(value)}
            allowClear
            style={{ width: "100%" }}
            placeholder="เลือกหน่วยงาน (Division)"
            size="large"
          />
        </Col>

        {/* Department */}
        <Col xs={24} sm={12} md={12} lg={7} xl={7}>
          <div className="filter-label">สายงาน (Department)</div>
          <Select
            mode="multiple"
            options={departmentOption}
            value={selectedDepartment}
            onChange={(value) => setSelectedDepartment(value)}
            allowClear
            style={{ width: "100%" }}
            placeholder="เลือกสายงาน (Department)"
            size="large"
          />
        </Col>

        {/* Export Full Report*/}
        <Col
          xs={24}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            label="Export to Excel"
            icon="pi pi-file-excel"
            loading={loading}
            onClick={exportFullReport}
            className="button-export-excel-all"
          />
        </Col>
      </Row>

      {/* ตารางรายได้ */}
      <div>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginTop: "2rem" }}
        >
          <div className="text-body-report">รายได้</div>
          <Button
            label="Export to Excel"
            icon="pi pi-file-excel"
            loading={loading}
            onClick={() => {
              exportSectionReport(
                "FTIBudgetByDepartmentFiscalYear_รายได้_" + selectedYear,
                "รายได้",
                "รายได้",
                incomeColumns,
                incomeData,
                "รวมรายได้",
              );
            }}
            className="button-export-excel"
          />
        </Row>
        <Row style={{ marginTop: "1rem" }}>
          <Col span={24}>
            <Table
              className="budget-table"
              style={{ width: "100%" }}
              scroll={{ x: "max-content" }}
              columns={incomeColumns}
              dataSource={incomeData}
              loading={loading}
              rowKey="key"
              bordered={false}
              pagination={{ pageSize: pageSize }}
              size="small"
              summary={() => {
                const dataSource =
                  filterIncomeData !== null ? filterIncomeData : incomeData;

                if (!incomeColumns.length) return null;

                const leafColumns = getLeafColumns(incomeColumns);
                const totalRow: any = {};

                leafColumns.forEach((col: any) => {
                  if (
                    col.dataIndex !== "AccountCode" &&
                    col.dataIndex !== "AccountName"
                  ) {
                    totalRow[col.dataIndex] = dataSource.reduce(
                      (sum: number, row: any) =>
                        sum + (Number(row[col.dataIndex]) || 0),
                      0,
                    );
                  }
                });

                return (
                  <Table.Summary>
                    <Table.Summary.Row
                      className="footer-summary-row"
                      style={{ fontWeight: "bold" }}
                    >
                      <Table.Summary.Cell index={0}>
                        รวมรายได้
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />

                      {leafColumns.slice(2).map((col: any, i: number) => (
                        <Table.Summary.Cell key={i} index={i + 2} align="right">
                          {totalRow[col.dataIndex]?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          }) ?? "0.00"}
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
              onChange={(pagination, filters, sorter, extra) => {
                setFilterIncomeData(extra.currentDataSource);
                setIncomeTableKeys(extra.currentDataSource.map((r) => r.key));
              }}
            />
          </Col>
        </Row>
      </div>

      {/* ตารางค่าใช้จ่าย */}
      <div>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginTop: "2rem" }}
        >
          <div className="text-body-report">ค่าใช้จ่าย</div>
          <Button
            label="Export to Excel"
            icon="pi pi-file-excel"
            loading={loading}
            onClick={() =>
              exportSectionReport(
                "FTIBudgetByDepartmentFiscalYear_ค่าใช้จ่าย_" + selectedYear,
                "ค่าใช้จ่าย",
                "ค่าใช้จ่าย",
                expenseColumns,
                expenseData,
                "รวมค่าใช้จ่าย",
              )
            }
            className="button-export-excel"
          />
        </Row>
        <Row style={{ marginTop: "1rem" }}>
          <Col span={24}>
            <Table
              className="budget-table"
              columns={expenseColumns}
              dataSource={expenseData}
              rowKey="key"
              loading={loading}
              bordered={false}
              style={{ width: "100%" }}
              scroll={{ x: "max-content" }}
              pagination={{ pageSize: pageSize }}
              size="small"
              summary={() => {
                const dataSource =
                  filterExpenseData !== null ? filterExpenseData : expenseData;

                if (!expenseColumns.length) return null;

                const leafColumns = getLeafColumns(expenseColumns);

                const totalExpenseRow: any = {};
                const netRow: any = {};

                const incomeSource =
                  filterIncomeData !== null ? filterIncomeData : incomeData;

                leafColumns.forEach((col: any) => {
                  if (
                    col.dataIndex !== "AccountCode" &&
                    col.dataIndex !== "AccountName"
                  ) {
                    const totalExpense = dataSource.reduce(
                      (sum: number, row: any) =>
                        sum + (Number(row[col.dataIndex]) || 0),
                      0,
                    );

                    const totalIncome = incomeSource.reduce(
                      (sum: number, row: any) =>
                        sum + (Number(row[col.dataIndex]) || 0),
                      0,
                    );

                    totalExpenseRow[col.dataIndex] = totalExpense;
                    netRow[col.dataIndex] = totalIncome - totalExpense;
                  }
                });

                return (
                  <Table.Summary>
                    {/* รวมค่าใช้จ่าย */}
                    <Table.Summary.Row
                      className="footer-summary-row"
                      style={{ fontWeight: "bold" }}
                    >
                      <Table.Summary.Cell index={0}>
                        รวมค่าใช้จ่าย
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />
                      {leafColumns.slice(2).map((col: any, i: number) => (
                        <Table.Summary.Cell key={i} index={i + 2} align="right">
                          {totalExpenseRow[col.dataIndex]?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                            },
                          ) ?? "0.00"}
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>

                    {/* สุทธิ */}
                    <Table.Summary.Row
                      className="net-summary-row"
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#282F6A",
                        color: "white",
                      }}
                    >
                      <Table.Summary.Cell index={0}>สุทธิ</Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />
                      {leafColumns.slice(2).map((col: any, i: number) => (
                        <Table.Summary.Cell key={i} index={i + 2} align="right">
                          {netRow[col.dataIndex]?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          }) ?? "0.00"}
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
              onChange={(pagination, filters, sorter, extra) => {
                setFilterExpenseData(extra.currentDataSource);
                setExpenseTableKeys(extra.currentDataSource.map((r) => r.key));
              }}
            />
          </Col>
        </Row>
      </div>

      {/* ตารางสินทรัพย์ถาวร */}
      <div>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginTop: "2rem" }}
        >
          <div className="text-body-report">สินทรัพย์ถาวร</div>
          <Button
            label="Export to Excel"
            icon="pi pi-file-excel"
            loading={loading}
            onClick={() =>
              exportSectionReport(
                "FTIBudgetByDepartmentFiscalYear_สินทรัพย์_" + selectedYear,
                "สินทรัพย์ถาวร",
                "สินทรัพย์ถาวร",
                fixedAssetColumns,
                fixedAssetData,
                "รวมสินทรัพย์ถาวร",
              )
            }
            className="button-export-excel"
          />
        </Row>
        <Row style={{ marginTop: "1rem" }}>
          <Col span={24}>
            <Table
              className="budget-table"
              columns={fixedAssetColumns}
              dataSource={fixedAssetData}
              rowKey="key"
              loading={loading}
              bordered={false}
              style={{ width: "100%" }}
              scroll={{ x: "max-content" }}
              pagination={{ pageSize: pageSize }}
              size="small"
              summary={() => {
                const dataSource =
                  filterFixedAssetData !== null
                    ? filterFixedAssetData
                    : fixedAssetData;

                if (!fixedAssetColumns.length) return null;

                const leafColumns = getLeafColumns(fixedAssetColumns);
                const totalRow: any = {};

                leafColumns.forEach((col: any) => {
                  if (
                    col.dataIndex !== "AccountCode" &&
                    col.dataIndex !== "AccountName"
                  ) {
                    totalRow[col.dataIndex] = dataSource.reduce(
                      (sum: number, row: any) =>
                        sum + (Number(row[col.dataIndex]) || 0),
                      0,
                    );
                  }
                });

                return (
                  <Table.Summary>
                    <Table.Summary.Row
                      className="fixedAsset-summary-row"
                      style={{ fontWeight: "bold" }}
                    >
                      <Table.Summary.Cell index={0}>
                        รวมสินทรัพย์ถาวร
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />

                      {leafColumns.slice(2).map((col: any, i: number) => (
                        <Table.Summary.Cell key={i} index={i + 2} align="right">
                          {totalRow[col.dataIndex]?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          }) ?? "0.00"}
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
              onChange={(pagination, filters, sorter, extra) => {
                setFilterFixedAssetData(extra.currentDataSource);
                setFixedAssetTableKeys(
                  extra.currentDataSource.map((r) => r.key),
                );
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default BudgetByDepartmentFiscalYear;
